import { useApiPatch } from '@sierralabs/core-ui';
export function useApplyEntityDelta(id) {
    const { data, isLoading, error, patch } = useApiPatch(`entities/${id}/deltas`);
    return {
        updatedResult: data,
        isUpdating: isLoading,
        updateError: error,
        applyEntityDeltas: patch
    };
}
//# sourceMappingURL=useApplyEntityDelta.js.map